<template>
  <Directions />
</template>

<script>
import Directions from '@/components/admin/recommendations/Directions.vue'

export default {
  name: 'AdministrationDirections',
  components: { Directions }
}
</script>

<style scoped>

</style>
